import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { buildErrorMessage } from '@constants'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import AddPlanItemButton from '../AddPlanItemButton'
import { storeyToLabel } from '../utils'

interface Props {
  storey: string
  request: (
    projectId: string,
    storey: string,
    params: Record<string, string | number | boolean>,
  ) => Promise<void>
  params: Record<string, string | number | boolean>
  'data-cy'?: string
}

const SingleStoreyPositionPlanItem = ({ storey, request, params }: Props): ReactElement => {
  const { enqueueSnackbar } = useSnackbar()
  const { projectId } = useParams()
  const queryClient = useQueryClient()

  const storeyLabel = storeyToLabel(storey)

  const { isLoading, mutate } = useMutation(
    (storey: string) => {
      return request(projectId as string, storey, params)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getPlans', projectId])
        enqueueSnackbar('Plan wurde erfolgreich erstellt', { variant: 'success' })
      },
      onError: (e: Error) => {
        enqueueSnackbar(buildErrorMessage(e, 'Fehler beim Erstellen der Pläne'), {
          variant: 'error',
        })
      },
    },
  )

  return (
    <AddPlanItemButton
      title={`${storeyLabel}`}
      isLoading={isLoading}
      onClick={() => mutate(storey)}
    />
  )
}

export default SingleStoreyPositionPlanItem
